import React, { useEffect, useState } from 'react';
import { IWebLinkScreenContent } from '../MobileAppTypes';
import { IScreenEditorProps } from './SharedTypes';

interface IWebLinkScreenEditorProps extends IScreenEditorProps {
  content: IWebLinkScreenContent;
}

const WebLinkScreenEditor: React.FC<IWebLinkScreenEditorProps> = ({
  content,
  errors,
  onContentChange,
  onFilesChange,
  onValidationChange
}) => {
  const [localContent, setLocalContent] = useState<IWebLinkScreenContent>(content);

  useEffect(() => {
    setLocalContent(content);
  }, [content]);

  const updateContent = (updates: Partial<IWebLinkScreenContent>) => {
    const newContent = { ...localContent, ...updates };
    setLocalContent(newContent);
    onContentChange(newContent);
    
    // Validate on change
    const validationErrors = validate(newContent);
    onValidationChange(validationErrors);
  };

  const validate = (contentToValidate: IWebLinkScreenContent = localContent): string[] => {
    const errors: string[] = [];
    if (!contentToValidate.url || !contentToValidate.url.trim()) {
      errors.push('URL is required');
    } else {
      try {
        new URL(contentToValidate.url);
      } catch {
        errors.push('Please enter a valid URL');
      }
    }
    return errors;
  };

  return (
    <div className="form-section">
      <h4>Web Link Screen Content</h4>
      <p className="text-muted">
        Opens a website in the device's default browser. When users tap this screen, it will launch the external browser app.
      </p>
      
      <div className="form-horizontal">
        <div className="form-group">
          <label className="col-sm-3 control-label">URL*</label>
          <div className="col-sm-9">
            <input 
              type="url" 
              className="form-control" 
              value={localContent.url} 
              onChange={(e) => updateContent({ url: e.target.value })} 
              placeholder="https://example.com" 
            />
            <span className="help-block">
              Enter the complete URL including https://
            </span>
          </div>
        </div>

        <div className="form-group">
          <label className="col-sm-3 control-label">Title</label>
          <div className="col-sm-9">
            <input 
              type="text" 
              className="form-control" 
              value={localContent.title || ''} 
              onChange={(e) => updateContent({ title: e.target.value })} 
              placeholder="Optional display title" 
            />
            <span className="help-block">
              Optional title to display for this link in the app
            </span>
          </div>
        </div>

        {/* Hidden for now, may re-enable later
        <div className="form-group">
          <label className="col-sm-3 control-label">Open Behavior</label>
          <div className="col-sm-9">
            <div className="checkbox">
              <label>
                <input
                  type="checkbox"
                  checked={localContent.openInNewTab !== false}
                  onChange={(e) => updateContent({ openInNewTab: e.target.checked })}
                />
                Open in new tab/window
              </label>
            </div>
            <span className="help-block">
              Whether to open the link in a new browser tab or replace the current page
            </span>
          </div>
        </div>
        */}
      </div>
    </div>
  );
};

export default WebLinkScreenEditor;